<template lang="pug">
div
	lessonHeader
	lessonTitle
	slides
	lessonFooter
</template>

<script>

import { mapGetters } from 'vuex';
import lessonHeader from "@/components/lesson-header/lesson-header";
import lessonTitle from '@/components/lesson-title/lesson-title'
import slides from '@/components/slides/slides'
import lessonFooter from "@/components/lesson-footer/lesson-footer";

export default {
	name: 'Escenario2',
	components:{
		lessonHeader,
		lessonTitle,
		slides,
		lessonFooter
	}
}
</script>

<style scoped>
@import 'scenario.scss';
</style>